import Highcharts from 'highcharts';

import { Component, useState } from "react"


class CHighcharts extends Component {
  id = 'genericchart'
  state = {
    init: false,
    container: false,
    
  }
  constructor (props) {
    super(props)
    this.id = this.props.id || this.id
    // console.log('construtot modal')
  }
  componentDidUpdate (props, state) {
    
    if (this.state.container !== false && this.state.init) {
      // console.log(this.props.options)
      Highcharts.setOptions({
        lang: {
            thousandsSep: '.',
            decimalPoint: ','
        }
      });
      let chart = Highcharts.chart(this.id, this.props.options);
      this.props.callbackchart(chart)
    }
  }

  componentWillUnmount  () {
    
  }
  componentDidMount (props, state) {
    // console.log('gggggggggg', this.props, this.state)
    // console.log(this.props.footer)
    
    setTimeout(() => {
      this.setState({
        init: true,
        container: <div id={ this.id }></div>
      })
      // console.log(this.state.container)
    }, 500)

    // console.log(this.state.container)
    
  }
  render () {
    return (
      this.state.init ? this.state.container : (this.props.loader ? this.props.loader : <h1>Cargando</h1>)
    )
  }
      // setActive(props.active !== activec? props.active: false)
    // const page_data = useSelector((state) => {
    //     // console.log(state)
    //     return state.HeroBarReducer
    // });

        
    
}

export default CHighcharts